var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/Z-Logo.png"),"alt":"Z Energy Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }